module.exports = __webpack_public_path__ + "img/precinct.9e9ae079.svg";